var GolSignCount=0;  //记录签章次数
var file,loadingClose,callback,pr;
import Vue from 'vue';
import {PDFSignCloudThread} from './esaclient.js'
function ESASignSerClear(serpath, state, isboolean, params){
    var Golparams ={"command":101, "code":4, "parameter":[]};    //code为4时是清理
    var data =JSON.stringify(Golparams);
    data = Base64.encode(data);
    $.ajax({
        type : "get",
        async:false,
        url :"http://127.0.0.1:16888?data="+data,
        dataType : "jsonp",
        jsonp: "callback",//传递给请求处理程序或页面的，用以获得jsonp回调函数名的参数名(默认为:callback)
        jsonpCallback:"success_jsonpCallback",//自定义的jsonp回调函数名称，默认为jQuery自动生成的随机函数名
        success : function(json){
            if(json.error == 0)
            {
               return ESASignSerStart(serpath, state, isboolean, params);   //清理完成后继续盖章
            }
            else
            {
              Vue.prototype.$notify.error({
                title: '错误',
                message: json.msg,
              });
              loadingClose.close();
              return null;
            }
        },
        error : function() {
          Vue.prototype.$notify.error({
            title: '错误',
            message: "签章失败，请检查签章服务是否启动",
          });
          loadingClose.close();
          return null;
        }
    });
}

//普通盖章POST
function ESASignSerStart(serpath, state, isboolean, params) {
  debugger
    var states = state + "";
    var isbooleans = isboolean + "";
    var Golparams = {"command" : 101,"code" : 17,"parameter" : [ serpath, states, isbooleans, params ]};
    var data = JSON.stringify(Golparams);
    data = Base64.encode(data);
    $.ajax({
        type : "get",
        async:false,
        url : "http://127.0.0.1:16888?data=" + data,
        dataType : "jsonp",
        jsonp : "callback",//传递给请求处理程序或页面的，用以获得jsonp回调函数名的参数名(默认为:callback)
        jsonpCallback : "success_jsonpCallback",//自定义的jsonp回调函数名称，默认为jQuery自动生成的随机函数名
        success : function(json) {
            if (json.error == 0) {
                GolSignCount=GolSignCount+1;
                var parameterRet = json.parameter[0];
                var jsonTemp = JSON.parse(parameterRet);
                var jsonResult = jsonTemp.result;
                var resultError='';
                var resultSuccess='';
                var resultSuccessData = [];
                var resultErrorData = [];
                for(var i = 0; i < jsonResult.length; i++) {
                  if (jsonResult[i].error) {
                    resultErrorData.push("/" + jsonResult[i].fileName);
                    resultError += decodeURI(jsonResult[i].fileName.substring(jsonResult[i].fileName.lastIndexOf("/")))+ " || ";
                  } else {
                    resultSuccessData.push("/" + jsonResult[i].fileName);
                    resultSuccess += decodeURI(jsonResult[i].fileName.substring(jsonResult[i].fileName.lastIndexOf("/")+1)) + " || ";
                  }
                }
                if(resultError!=''){
                  Vue.prototype.$notify.error({
                    title: '签章失败',
                    message: resultError+'-签章失败，请重试',
                    duration: 0
                  });
                }
                if(file!='' && file!=null){
                  window.open(file, "_blank");
                }
                // if(QR){
                //   AddQRcode(_content, _serpath, _signedPdfPath)
                // }
                if(resultSuccess!=''){
                   Vue.prototype.$notify.success({
                     title: '签章成功',
                     message: resultSuccess+'-签章成功',
                     duration: 0
                   });
                }
                callback(resultSuccessData,resultErrorData)
            } else{
              Vue.prototype.$notify.error({
                title: '签章失败',
                message: json.msg,
              });
            }
          loadingClose.close();
        },
        error : function() {
          Vue.prototype.$notify.error({
            title: '签章失败',
            message: "签章过程失败",
          });
          loadingClose.close();
        }
    });
}

export function startSign(signType,signedPdfPath,filePath,loading,position,method) { //1公章 2个人签名
    loadingClose = loading ;
    file = filePath;
    callback = method;
    var serpath = "";
    $.ajax({
      type : "GET",
      traditional: true,
      async:false,
      url : "/draw/sysFunctionsIntroduce?code=sign_path",
      success : function(json) {
        serpath = json.result.data[0].content//云签中间件服务器地址
      },
      error : function() {
        Vue.prototype.$notify.error({
          title: '签章失败',
          message: "签章地址获取失败",
        });
        loadingClose.close();
      }
    });
    //var serpath = "http://127.0.0.1:8020/PDFSignForLinux/servlet";
    //云签中间件服务器地址
    var signCmd = getCommand(position,null);                                          //根据不同的功能返回的组合参数
    //组合参数说明：
    var params = "&signfile=" + signedPdfPath +  "&signCmd=" + signCmd;   //&signfile=文档名称&signCmd=组合指令

    //通过JION传递指令给客户端软件
    try {
        //ESASignSerClear(serpath, 4, 0, params);   //QR签名
        ESASignSerClear(serpath, signType, 1, params);    //普通签章  多位置签章 骑缝印章
        // if ($("#BarcodeSeal").is(":checked")) { //QR条码
				// 		ESASignSerClear(serpath, 4, 0, params);   //QR签名
				// }


    } catch (e) {
      Vue.prototype.$notify.info({
        title: '提示',
        message: "请安装正确的客户端！",
      });
      loadingClose.close();
    }

}
export function startSignKey(signType,signedPdfPath,filePath,loading,position,method,key) { //1公章 2个人签名
  loadingClose = loading ;
    file = filePath;
    callback = method;
    var serpath = "";
    $.ajax({
      type : "GET",
      traditional: true,
      async:false,
      url : "/draw/sysFunctionsIntroduce?code=sign_path",
      success : function(json) {
        serpath = json.result.data[0].content//云签中间件服务器地址
      },
      error : function() {
        Vue.prototype.$notify.error({
          title: '签章失败',
          message: "签章地址获取失败",
        });
        loadingClose.close();
      }
    });
    //var serpath = "http://127.0.0.1:8020/PDFSignForLinux/servlet";
    //云签中间件服务器地址
    var signCmd = getCommand(position,key);                                          //根据不同的功能返回的组合参数
    //组合参数说明：
    var params = "&signfile=" + signedPdfPath +  "&signCmd=" + signCmd;   //&signfile=文档名称&signCmd=组合指令

    //通过JION传递指令给客户端软件
    try {
        //ESASignSerClear(serpath, 4, 0, params);   //QR签名
        ESASignSerClear(serpath, signType, 1, params);    //普通签章  多位置签章 骑缝印章
        // if ($("#BarcodeSeal").is(":checked")) { //QR条码
				// 		ESASignSerClear(serpath, 4, 0, params);   //QR签名
				// }


    } catch (e) {
      Vue.prototype.$notify.info({
        title: '提示',
        message: "请安装正确的客户端！",
      });
      loadingClose.close();
    }
}

var _serpath,_signedPdfPath,_content
var QR = false;
export function startSign_batch(signType,signedPdfPath,filePath,loading,position,method,content) { //1公章 2个人签名
  loadingClose = loading ;
  file = filePath;
  callback = method;
  let serpath = "";
  $.ajax({
    type : "GET",
    traditional: true,
    async:false,
    url : "/draw/sysFunctionsIntroduce?code=sign_path",
    success : function(json) {
      serpath = json.result.data[0].content//云签中间件服务器地址
    },
    error : function() {
      Vue.prototype.$notify.error({
        title: '签章失败',
        message: "签章地址获取失败",
      });
      loadingClose.close();
    }
  });
  //var serpath = "http://127.0.0.1:8020/PDFSignForLinux/servlet";
  //云签中间件服务器地址
  var signCmd = getCommand(position,null);                                          //根据不同的功能返回的组合参数
  //组合参数说明：
  var params = "&signfile=" + signedPdfPath +  "&signCmd=" + signCmd;   //&signfile=文档名称&signCmd=组合指令
  _serpath = serpath;
  _signedPdfPath = signedPdfPath;
  _content = content;
  QR = true;
  //通过JION传递指令给客户端软件
  try {
    //ESASignSerClear(serpath, 4, 0, params);   //QR签名
    ESASignSerClear(serpath, signType, 1, params);//普通签章  多位置签章 骑缝印章
    // if ($("#BarcodeSeal").is(":checked")) { //QR条码
    // 		ESASignSerClear(serpath, 4, 0, params);   //QR签名
    // }
  } catch (e) {
    Vue.prototype.$notify.info({
      title: '提示',
      message: "请安装正确的客户端！",
    });
    loadingClose.close();
  }finally {
  }
}

function JsPdfSignCloudThread(status,msg,retpar,params)
{
  if (status == 0)
  {
    Vue.prototype.$notify.success({
      title: '生成成功',
      message: "二维码已添加",
    });
  }
  else
  {
    Vue.prototype.$notify.error({
      title: '生成失败',
      message: "二维码生成错误",
    });
  }
}
function AddQRcode(param,serpath,file)
{
  param = Base64.encode(param);    //BASE64条码数据内容
  let m_QRWidth = 100
  let m_QRHeight = 100
  let m_SignPage = 0
  let m_SignPageX = 2300
  let m_SignPageY = 1650
  let m_SignVisable = 1
  //BarcodeSeal:BASE64(条码数据内容),条码宽度,条码高度,X坐标,Y坐标,页码,是否签名;
  let signCmd = "BarcodeSeal:" + param + "," + m_QRWidth+ "," + m_QRHeight + "," + m_SignPageX + ","+ m_SignPageY + "," + m_SignPage + ","+ m_SignVisable + ";";

  //组合参数说明：
  let params = "&signfile=" + file +  "&signCmd=" + signCmd;   //&signfile=文档名称&signCmd=组合指令
  //长度检查，如果单次文档太多，则要分多次请求
  let data = Base64.encode(params);
  if(data.length>1900)
  {
    alert("GET请求长度有限制，当前不能超过1900，当前请求长度为："+data.length);
    alert("一次传入的参数过长，请减少签章文档数量");
  }
  if(m_SignVisable==1){
    PDFSignCloudThread(serpath,4,0,params,JsPdfSignCloudThread,null,false);  //QR带签名
  }
  else{
    PDFSignCloudThread(serpath,3,0,params,JsPdfSignCloudThread,null,false);  //QR不带签名
  }
}

//获取组合指令
function getCommand(position,key) {
        var signCmd = "";     //组合指令
        var SigleSeal_PageNum = "";   //页码
        var SigleSeal_XPos = "";         //X坐标
        var SigleSeal_YPos = "";         //Y坐标
        if(position==='leftBottom'){
          SigleSeal_PageNum = 0;         //页码
          SigleSeal_XPos = 500;         //X坐标
          SigleSeal_YPos =2300;         //Y坐标
        }else if(position==='rightBottom'){
          SigleSeal_PageNum = 0;         //页码
          SigleSeal_XPos = 132;         //X坐标
          SigleSeal_YPos =598;         //Y坐标
        }else if(position==='rightBottom_ms'){
          SigleSeal_PageNum = 0;         //页码
          SigleSeal_XPos = 200;         //X坐标
          SigleSeal_YPos =800;         //Y坐标
        }else if(position==='leftUpBottom'){//电气
          SigleSeal_PageNum = 0;         //页码
          SigleSeal_XPos = 400;         //X坐标
          SigleSeal_YPos =500;         //Y坐标
        }else if(position==='leftUpBottomFL'){//防雷
          SigleSeal_PageNum = 1;         //页码
          SigleSeal_XPos = 2200;         //X坐标
          SigleSeal_YPos =800;         //Y坐标
        }else if(position==='rightBottom1'){
          SigleSeal_PageNum = 2;         //页码
          SigleSeal_XPos = 140;         //X坐标
          SigleSeal_YPos =620;         //Y坐标
        }else if(position==='rightBottom2'){
          SigleSeal_PageNum = 2;         //页码
          SigleSeal_XPos = 180;         //X坐标
          SigleSeal_YPos =550;         //Y坐标
        }else if(position==='rightBottom13'){
          SigleSeal_PageNum = 3;         //页码
          SigleSeal_XPos = 80;         //X坐标
          SigleSeal_YPos =600;         //Y坐标
        }else if(position==='rightBottom4'){
          SigleSeal_PageNum = 3;         //页码
          SigleSeal_XPos = 305;         //X坐标
          SigleSeal_YPos =440;         //Y坐标
        }else if(position==='rightBottom5'){
          SigleSeal_PageNum = 3;         //页码
          SigleSeal_XPos = 280;         //X坐标
          SigleSeal_YPos =520;         //Y坐标
        }else if(position==='rightBottom6'){
          SigleSeal_PageNum = 3;         //页码
          SigleSeal_XPos = 280;         //X坐标
          SigleSeal_YPos =520;         //Y坐标
        }else if(position==='rightBottom7'){
          SigleSeal_PageNum = 2;         //页码
          SigleSeal_XPos = 80;         //X坐标
          SigleSeal_YPos =600;         //Y坐标
        }else if(position==='rightBottom10'){
          SigleSeal_PageNum = 4;         //页码
          SigleSeal_XPos = 140;         //X坐标
          SigleSeal_YPos =550;         //Y坐标
        }else if(position==='rightBottom11'){
          SigleSeal_PageNum = 4;         //页码
          SigleSeal_XPos = 180;         //X坐标
          SigleSeal_YPos =450;         //Y坐标
        }else if(position==='rightBottom14'){
          SigleSeal_PageNum = 3;         //页码
          SigleSeal_XPos = 80;         //X坐标
          SigleSeal_YPos =540;         //Y坐标
        }else if(position==='charge'){
          SigleSeal_PageNum = 0;         //页码
          SigleSeal_XPos = 180;         //X坐标
          // SigleSeal_YPos =598;
          SigleSeal_YPos = 420;         //Y坐标S
        }else if(position==='commonSeal'){//公章 //气象、人防
          SigleSeal_PageNum = 0;         //页码
          SigleSeal_XPos = 140;         //X坐标
          SigleSeal_YPos =620;         //Y坐标
        }else if(position==='corporateSeal'){//法人章 //规划
          SigleSeal_PageNum = 0;         //页码
          SigleSeal_XPos = 100;         //X坐标
          SigleSeal_YPos =720;
        }else if(position==='leftUpBottom3'){
          SigleSeal_PageNum = 0; 
          SigleSeal_XPos = 440;         //X坐标
          SigleSeal_YPos =760;
        }else if(position==='leftUpBottom4'){
          SigleSeal_PageNum = 0; 
          SigleSeal_XPos = 440;         //X坐标
          SigleSeal_YPos =790;
        }
        var SigleSeal_coordPos = 3; //1- 左下角，2- 左上角，3- 右上角，4- 右下角
        var SigleSeal_moveDire = 0; //0- 向右移动，1- 向左移动，2- 向上移动，3- 向下移动
        if(key!=null){
          var SigleSeal_KeyWord = key; //关键字
					var SigleSeal_KPage =   0;     //页码:0所有页,1为第页,1-4为1到4页
					var SigleSeal_XPotion = 0;   //偏移X坐标
          var SigleSeal_YPotion = 0;   //偏移Y坐标
          if(position==='JSFZR'){
            SigleSeal_KPage = 0;         //页码
            SigleSeal_XPotion = 200;         //X坐标
            SigleSeal_YPotion =0;         //Y坐标
          }if(position==='LEFT'){
            //  
            SigleSeal_KPage = 0;         //页码
            SigleSeal_XPotion = 180;         //X坐标
            SigleSeal_YPotion =10;         //Y坐标
          }
          if(position==='LEFT1'){
            //  
            SigleSeal_KPage = 0;         //页码
            SigleSeal_XPotion = 100;         //X坐标
            SigleSeal_YPotion =0;         //Y坐标
          }else if(position==='kc_yjs'){
            SigleSeal_KPage = 0;         //页码
            SigleSeal_XPotion = -260;         //X坐标
            SigleSeal_YPotion =-600;
          }
          var params = SigleSeal_KeyWord + ","+ SigleSeal_KPage + ","+ SigleSeal_XPotion + ","+ SigleSeal_YPotion;   //关键字,页码,偏移X坐标,偏移Y坐标
					params =Base64.encode(params);  //BASE64编码

					//带时间定位偏移参数
					var timeSealKey_X = "";
					var timeSealKey_Y = "";
					var fontsizekey = "";
					if((timeSealKey_X!="")&&(timeSealKey_Y!="")&&fontsizekey!="")
					{
						signCmd = "SealByKeyWord:" + params +":"+timeSealKey_X+","+timeSealKey_Y+","+fontsizekey+";";  //SealByKeyWord:BASE64(关键字,页码,偏移X坐标,偏移Y坐标):时间X,时间Y,字体大小;
					}
					else
					{
						signCmd = "SealByKeyWord:" + params + ";";  //SealByKeyWord:BASE64(关键字,页码,偏移X坐标,偏移Y坐标);
					}

					var rotate =  0; //获取设置印章旋转度值
					if((rotate =="0")||(rotate =="90")||(rotate =="180")||(rotate =="270"))
					{
						return signCmd+rotate+";";      //SealByKeyWord:BASE64(关键字,页码,偏移X坐标,偏移Y坐标):时间X,时间Y,字体大小;旋转度;
					}
					else
					{
						return signCmd;      //SealByKeyWord:BASE64(关键字,页码,偏移X坐标,偏移Y坐标):时间X,时间Y,字体大小;
					}
        }else{
          signCmd = "SealByXYPos:" + SigleSeal_XPos + "," + SigleSeal_YPos + "," + SigleSeal_PageNum + ","+ SigleSeal_coordPos;  //SealByXYPos:x,y,页码,参考定点

          if(SigleSeal_moveDire !="")                       //印章允许重叠，无偏移参数（是否允许重叠通过是否有偏移参数控制）
          {
              signCmd = signCmd + ","+ SigleSeal_moveDire; //SealByXYPos:x,y,页码,参考定点,偏移方向
          }
          signCmd = signCmd + ";"  //x,y,页码,参考定点,偏移方向;

          var rotate =  0;    //获取设置印章旋转度值
          if((rotate =="0")||(rotate =="90")||(rotate =="180")||(rotate =="270"))
          {
              return signCmd+rotate+";";         //SealByXYPos:x,y,页码,参考定点,偏移方向:时间X,时间Y,字体大小;旋转度;
          }
          else
          {
              return signCmd;    //SealByXYPos:x,y,页码,参考定点,偏移方向:时间X,时间Y,字体大小;
          }
        }
}



//////////////////
// WEBPACK FOOTER
// ./static/CloudSign/js/commom.js
// module id = ANI4
// module chunks = 159